import { useTranslation } from 'react-i18next';
import { Tabs, TabsList, TabsTrigger } from '@xxtract/ui';
import type { OrdersTab } from '../ordersLijst';

interface OrdersTabsProps {
  tab: OrdersTab;
  attentionCount: number | null;
  onholdCount: number | null;
  onChange: (tab: OrdersTab) => void;
}

/** fu-6/AC2: Alle / Aandacht nodig (N) / Onhold (N) — replaces the standalone toggle button. An unknown
 * count (null: loading, rejected or failed) shows only the tab name, never a misleading "(0)". */
export function OrdersTabs({ tab, attentionCount, onholdCount, onChange }: OrdersTabsProps) {
  const { t } = useTranslation();

  return (
    <Tabs value={tab} onValueChange={(value) => onChange(value as OrdersTab)}>
      <TabsList aria-label={t('orders.tabs.label')} className="h-auto max-w-full flex-wrap">
        <TabsTrigger data-testid="orders-tab-all" value="all">{t('orders.tabs.all')}</TabsTrigger>
        <TabsTrigger data-testid="orders-tab-attention" value="attention">
          {attentionCount == null ? t('orders.tabs.attentionNoCount') : t('orders.tabs.attention', { count: attentionCount })}
        </TabsTrigger>
        <TabsTrigger data-testid="orders-tab-onhold" value="onhold">
          {onholdCount == null ? t('orders.tabs.onholdNoCount') : t('orders.tabs.onhold', { count: onholdCount })}
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
